export default __webpack_public_path__ + "static/whatsapp-1268ec9e502eb5b1f624dd67a67b7b12.png";